// Generated by purs version 0.13.8
"use strict";
var Data_Array = require("../Data.Array/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Set = require("../Data.Set/index.js");
var Lunarbox_Data_Dataflow_Class_Substituable = require("../Lunarbox.Data.Dataflow.Class.Substituable/index.js");
var Lunarbox_Data_Dataflow_Expression = require("../Lunarbox.Data.Dataflow.Expression/index.js");
var Lunarbox_Data_Dataflow_Runtime_Class_Runnable = require("../Lunarbox.Data.Dataflow.Runtime.Class.Runnable/index.js");
var Lunarbox_Data_Dataflow_Runtime_Class_Typeable = require("../Lunarbox.Data.Dataflow.Runtime.Class.Typeable/index.js");
var Lunarbox_Data_Dataflow_Scheme = require("../Lunarbox.Data.Dataflow.Scheme/index.js");
var Type_Proxy = require("../Type.Proxy/index.js");
var DProxy = function (x) {
    return x;
};
var Describable = function (Runnable0, Typeable1) {
    this.Runnable0 = Runnable0;
    this.Typeable1 = Typeable1;
};
var typeableDProxy = function (dictTypeable) {
    return new Lunarbox_Data_Dataflow_Runtime_Class_Typeable.Typeable(function (v) {
        return Lunarbox_Data_Dataflow_Runtime_Class_Typeable["typeof"](dictTypeable)(Type_Proxy["Proxy"].value);
    });
};
var runnableDProxy = function (dictRunnable) {
    return new Lunarbox_Data_Dataflow_Runtime_Class_Runnable.Runnable(function (v) {
        return Lunarbox_Data_Dataflow_Runtime_Class_Runnable.toRuntime(dictRunnable)(v);
    });
};
var generalizeType = function (ty) {
    return new Lunarbox_Data_Dataflow_Scheme.Forall(Data_Array.fromFoldable(Data_Set.foldableSet)(Lunarbox_Data_Dataflow_Class_Substituable.ftv(Lunarbox_Data_Dataflow_Class_Substituable.typeSubst)(ty)), ty);
};
var toNativeExpression = function (dictDescribable) {
    return function (value) {
        var ty = generalizeType(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.getType(dictDescribable.Typeable1())(value));
        var runtimeValue = Lunarbox_Data_Dataflow_Runtime_Class_Runnable.toRuntime(dictDescribable.Runnable0())(value);
        return new Lunarbox_Data_Dataflow_Expression.NativeExpression(ty, runtimeValue);
    };
};
var describableA = function (dictRunnable) {
    return function (dictTypeable) {
        return new Describable(function () {
            return dictRunnable;
        }, function () {
            return dictTypeable;
        });
    };
};
var corunnableDProxy = function (dictCorunnable) {
    return new Lunarbox_Data_Dataflow_Runtime_Class_Runnable.Corunnable(function (a) {
        return Data_Functor.map(Data_Maybe.functorMaybe)(DProxy)(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.fromRuntime(dictCorunnable)(a));
    });
};
module.exports = {
    DProxy: DProxy,
    Describable: Describable,
    generalizeType: generalizeType,
    toNativeExpression: toNativeExpression,
    runnableDProxy: runnableDProxy,
    typeableDProxy: typeableDProxy,
    corunnableDProxy: corunnableDProxy,
    describableA: describableA
};
